interface BrandMarkProps { className?: string }
export const brandMarkUrl = '/brand/wyan-toolbox-mark.svg';
export function BrandMark({ className = '' }: BrandMarkProps) {
  return <img alt="" aria-hidden="true" className={`brand-logo-image ${className}`.trim()} draggable={false} height={40} src={brandMarkUrl} width={40} />;
}
